import { Spinner } from 'apps/customer/src/components';
import { useEffect, useState } from 'react';
import { PaymentCardItem } from './PaymentCardItem';
import { Button } from '@unified-checkout/design-system';
import { usePaymentMethods, useSetDefaultCard } from 'apps/customer/src/services/inner_layout/paymentMethods';
import { AddPaymentMethod } from './AddPaymentMethod';
export const PaymentMethods = () => {
  
  const { data: paymentMethodsResponse, isLoading: isLoadingPaymentMethods } =
  usePaymentMethods();
  const paymentMethods = paymentMethodsResponse?.results;
  
  const [isAddingPayment, setIsAddingPayment] = useState<boolean>();
  
  useEffect(() => {
    if (!isLoadingPaymentMethods) setIsAddingPayment(!paymentMethods?.length);
  }, [isLoadingPaymentMethods, paymentMethods?.length]);

  const {mutate: setIsDefaultMutation} = useSetDefaultCard();
  
  useEffect(() => {
    if (paymentMethods?.length === 1) {
      const isCardDefault = paymentMethods?.some((method) => method.is_default);
      if (!isCardDefault) {
        const defaultPaymentMethodId = paymentMethods?.[0]?.unique_id;
        setIsDefaultMutation({ unique_id: defaultPaymentMethodId });
      }
    }
  }, [paymentMethods?.length]);
  
  return (
    <section className="flex flex-col">
      <h2 className="page-title">Payment methods</h2>
      <section className="space-y-3">
        {isLoadingPaymentMethods && <Spinner />}
        {paymentMethods?.map((method) => (
          <PaymentCardItem key={method.unique_id} method={method} />
        ))}
        <AddPaymentMethod show={isAddingPayment} />
      </section>
      {!isAddingPayment && (
        <div className="my-5">
          <Button
            color="primary"
            text="+ Add payment method"
            size="md"
            type="button"
            variant="link"
            onClickHandler={() => setIsAddingPayment((prev) => !prev)}
          />
        </div>
      )}
    </section>
  );
};
